<template>
    <b-container class="podcasts-content">
        <b-row class="podcast-row" v-for="p in podcasts" :key="p.key">
            <b-col><iframe width="100%" height="120" v-bind:src="getPodcastSrc(p)" frameborder="0" ></iframe></b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    data () {
        return {
            podcasts: null
        }
    },
    created: function() {
        this.loadPodcasts();
    },
    methods: {
        loadPodcasts() {
            this.$http.get('https://api.mixcloud.com/empradio/cloudcasts/')
            .then(response => {
                console.log(response);
                this.podcasts = response.data.data;
            })
        },
        getPodcastSrc(podcast) {
            return 'https://www.mixcloud.com/widget/iframe/?hide_cover=1&feed=' + encodeURI(podcast.key);
        }
    }
}
</script>

<style>
    .podcast-row {
        margin-top: 10px;
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/Podcasts.vue